<!-- eslint-disable vue/no-v-html -->
<template>
  <q-dialog ref="dialogRef" :persistent="persistent">
    <q-card
      class="q-dialog-plugin dark:bg-d-neutral-10 rounded-lg max-w-[580px] w-full overflow-hidden flex flex-col flex-nowrap"
    >
      <header
        class="flex items-center bg-primary py-20 px-16 text-headline-2 rounded-t-lg justify-between"
      >
        <div
          class="flex items-center gap-8 text-headline-2 text-white"
        >
          <q-icon
            v-if="icon"
            :name="icon"
            class="w-[20px] h-[20px]"
          />
          {{ title }}
        </div>
        <OButton
          tertiary
          class="!p-0 place-items-center grid text-white cursor-pointer w-32 h-32"
          icon-size="24px"
          @click.stop.prevent="onDialogHide"
        >
          <q-icon name="close" />
        </OButton>
      </header>

      <div
        class="py-32 px-16 flex flex-col justify-between flex-1 overflow-y-auto"
      >
        <p
          class="text-paragraph-2 text-neutral-100 Modal-content"
          v-html="text"
        />
      </div>

      <div
        v-if="!alternativeButton.label"
        class="flex items-center justify-end gap-8 p-16 border-t border-solid border-neutral-100/10"
      >
        <OButton
          size="md"
          secondary
          class="dark:bg-d-neutral-40 dark:!border-transparent !px-14"
          @click="onDialogHide"
        >
          {{ cancelText }}
        </OButton>
        <OButton
          data-id="confirm-button"
          size="md"
          primary
          class="!px-14"
          @click="onDialogOK"
        >
          {{ confirmText }}
        </OButton>
      </div>
      <div
        v-else
        class="flex items-center justify-between p-16 border-t border-solid border-neutral-100/10"
      >
        <OButton
          size="md"
          secondary
          class="dark:bg-d-neutral-40 dark:!border-transparent !px-14"
          @click="onDialogHide"
        >
          {{ cancelText }}
        </OButton>

        <div class="flex items-center gap-8">
          <OButton
            size="md"
            secondary
            class="dark:bg-d-neutral-40 dark:!border-transparent !px-14"
            @click="alternativeButton.action"
          >
            {{ alternativeButton.label }}
          </OButton>
          <OButton
            data-id="confirm-button"
            size="md"
            primary
            class="!px-14"
            @click="onDialogOK"
          >
            {{ confirmText }}
          </OButton>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { useDialogPluginComponent } from 'quasar'

import OButton from 'components/Button/OButton.vue'

const { dialogRef, onDialogOK, onDialogCancel, onDialogHide } =
  useDialogPluginComponent()

const props = defineProps({
  title: { type: String, default: '' },
  text: { type: String, default: '' },
  icon: { type: String, default: '' },
  persistent: { type: Boolean, default: false },
  confirmText: { type: String, default: 'Confirmar' },
  cancelText: { type: String, default: 'Cancelar' },

  alternativeButton: {
    type: Object,
    default: () => ({ label: '', action: () => {} }),
  },
})

defineEmits([...useDialogPluginComponent.emits])

defineExpose({
  dialogRef,
})
</script>
